import { Mail, Phone } from "lucide-react";
import { useSellerLeads } from "@/hooks/useSellerLeads.js";
import { Table, TableHead, TableBody, TableRow, TableHeader, TableCell } from "@/components/ui/table.js";
import { Badge } from "@/components/ui/badge.js";

export default function SellerLeads(): JSX.Element {
  const { data = [], isLoading } = useSellerLeads();

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-h1 font-display text-ink">Vendi casa · lead</h1>
        <p className="text-body text-ink-soft">{data.length} lead totali</p>
      </header>

      <div className="overflow-x-auto rounded border border-rule bg-surface">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader className="w-[180px]">Ricevuto</TableHeader>
              <TableHeader>Immobile</TableHeader>
              <TableHeader className="w-[110px]">Tipo</TableHeader>
              <TableHeader className="w-[80px]">Mq</TableHeader>
              <TableHeader>Contatto</TableHeader>
              <TableHeader className="w-[120px]">Stato</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.id}>
                <TableCell className="font-mono text-meta text-ink">{new Date(row.created_at).toLocaleString("it-IT")}</TableCell>
                <TableCell>
                  <p className="text-body-strong text-ink">{row.address}</p>
                  <p className="text-meta text-ink-soft">{row.city ?? "—"}</p>
                </TableCell>
                <TableCell className="font-mono text-meta uppercase text-ink-mute">{row.property_type}</TableCell>
                <TableCell className="font-mono text-meta text-ink">{row.mq ?? "—"}</TableCell>
                <TableCell>
                  <p className="text-body text-ink">{row.contact_name}</p>
                  <div className="flex flex-wrap items-center gap-2 text-meta text-ink-soft">
                    <a href={`mailto:${row.contact_email}`} className="inline-flex items-center gap-1 text-accent hover:underline">
                      <Mail className="size-3" /> {row.contact_email}
                    </a>
                    {row.contact_phone ? (
                      <a href={`tel:${row.contact_phone}`} className="inline-flex items-center gap-1 text-accent hover:underline">
                        <Phone className="size-3" /> {row.contact_phone}
                      </a>
                    ) : null}
                  </div>
                </TableCell>
                <TableCell><Badge>{row.status}</Badge></TableCell>
              </TableRow>
            ))}
            {!isLoading && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} className="py-12 text-center text-ink-mute">Nessun lead.</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
